import React from 'react'

import * as S from './styles'

const TableComponent: React.FC = ({ children }) => {
  return <S.Container>{children}</S.Container>
}

export default TableComponent
